
// initial state
const state = {
  list: ['je_white_letters', 'incoming_correspondence', 'js_white_letters', 'email', 'correspondence'],
};

// getters
const getters = {
};

// actions
const actions = {
};

// mutations
const mutations = {
  setCorrTypesList(state, playload) {
    state.list = playload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/corrTypes.js